import React, { ComponentType } from "react";

import dynamic, { LoadingComponentProps } from "next/dynamic";
import { LoadingFormDelightful } from "./LoadingFormDelightful";

const Loading: React.FC<LoadingComponentProps> = () => <LoadingFormDelightful />;

const DynamicQuoteForm = dynamic<ComponentType>(
  import("./QuoteForm").then(({ QuoteForm }) => QuoteForm),
  {
    loading: Loading,
    ssr: false
  }
);

export { DynamicQuoteForm };
